function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TxSignatureTemplate = require('./tx-signature.template');
function formatCreatedAt(value) {
  var n = Number(value);
  if (!Number.isFinite(n) || n <= 0) {
    return '—';
  }
  var ms = n < 1e12 ? n * 1000 : n;
  var date = new Date(ms);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}
var TxSignature = /*#__PURE__*/function () {
  function TxSignature(app, mod, signature) {
    _classCallCheck(this, TxSignature);
    this.app = app;
    this.mod = mod;
    this.signature = String(signature || '');
    this.container = '.explorer-view';
  }
  return _createClass(TxSignature, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.mod.txSignatureComponent = this;
      this.paint();
    }
  }, {
    key: "paint",
    value: function paint() {
      var loading = !this.mod.txSignatureReady;
      var error = this.mod.txSignatureError ? this.app.browser.escapeHTML(this.mod.txSignatureError) : null;
      var result = this.mod.txSignatureResult || {};
      var status = String(result.status || '');
      var blockHash = String(result.block_hash || '');
      var blockId = String(result.block_id || '');
      var blockTarget = blockHash || blockId;
      var canVisitBlock = Boolean(blockTarget) && status && status !== 'UNCONFIRMED' && status !== 'NOT FOUND';
      this.app.browser.replaceElementContentBySelector(TxSignatureTemplate({
        loading: loading,
        error: error,
        signature: this.app.browser.escapeHTML(this.signature),
        status: this.app.browser.escapeHTML(status),
        blockId: this.app.browser.escapeHTML(blockId),
        blockHash: this.app.browser.escapeHTML(blockHash),
        blockHref: canVisitBlock ? "/explorer/block/".concat(encodeURIComponent(blockTarget)) : '',
        blockInput: canVisitBlock ? this.app.browser.escapeHTML(blockTarget) : '',
        transactionId: this.app.browser.escapeHTML(String(result.transaction_id || '')),
        longestChain: Number(result.lc) === 1 ? 'yes' : result.source === 'database' ? 'no' : '',
        createdAt: this.app.browser.escapeHTML(formatCreatedAt(result.created_at))
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('.explorer-utxo-block-link').forEach(function (link) {
        link.onclick = function (event) {
          event.preventDefault();
          var input = link.getAttribute('data-block-input');
          if (input) {
            _this.mod.renderBlock(input, {
              pushState: true,
              animate: true
            });
          }
        };
      });
    }
  }]);
}();
module.exports = TxSignature;